<template>
  <div class="aibot-container">
    <!-- AI球体 -->
    <div 
      class="aibot" 
      :class="{ 'expanded': isExpanded }"
      :style="ballStyle"
      @mousedown="startDrag"
      @click="toggleExpand"
      v-show="!isExpanded"
    >
    <div class="glow"></div>
      <div class="ai-ball">
        <div class="flow-gradient"></div>
        <div class="ball-inner">
         <BaseIcon icon="nbgz" :size="30" />
        </div>
    </div>
    <div class="ripple"></div>
    <div class="ripple"></div>
    <div class="ripple"></div>
      <div class="particles" ref="particles"></div>
    </div>

    <!-- 展开后的聊天界面 -->
    <transition name="expand">
      <div class="ai-chat-interface" v-show="isExpanded">
        <!-- 头部 -->
        <div class="ai-chat-header">
          <div class="ai-chat-header-left">
            <div class="ai-avatar">
              <div class="avatar-glow"></div>
              <BaseIcon icon="nbgz" :size="20" />
            </div>
            <span class="ai-name">高专助手</span>
          </div>
          <div class="ai-header-actions">
            <button class="minimize-btn" @click="toggleExpand">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M4 10H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </div>

        <!-- 消息列表 -->
        <div class="message-list" ref="messageList">
          <div 
            v-for="(msg, index) in messages" 
            :key="index"
            class="message-item"
            :class="msg.type"
          >
            <div class="message-avatar" v-if="msg.type === 'assistant'">AI</div>
            <div class="message-content">
              <div class="message-action" v-if="msg.action">
                <ExecutorCard :message="msg" />
              </div>
              <BaseMarkdownView class="message-text" v-else :value="msg.content" />
              <div class="message-time">{{ msg.time }}</div>
            </div>
            <div class="message-avatar" v-if="msg.type === 'user'">我</div>
          </div>
        </div>

        <!-- 快捷提示 -->
        <div class="quick-prompts" v-if="messages.length === 0">
          <div 
            v-for="(prompt, index) in prompts" 
            :key="index"
            class="prompt-item"
            @click="sendPrompt(prompt)"
          >
            <div class="prompt-text">{{ prompt.text }}</div>
          </div>
    </div>

        <!-- 输入框 -->
        <div class="input-container">
          <div class="input-wrapper">
            <input 
              type="text" 
              v-model="inputText"
              @keyup.enter="sendMessage"
              placeholder="输入你的问题..."
              class="chat-input"
            >
            <button 
              class="send-btn" 
              @click="sendMessage"
              :disabled="!inputText.trim()"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M18 2L9 11M18 2L12 18L9 11M18 2L2 8L9 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
    </div>
    </transition>
  </div>
</template>

<script>
import ExecutorCard from '@/components/ai/executor.vue'
export default {
  components: {
    ExecutorCard
  },
  data() {
    return {
      isExpanded: false,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      ballX: 0,
      ballY: 0,
      inputText: '',
      messages: [],
      prompts: [
        { text: '打开合约系统' },
        { text: '帮我优化这段文字' }
      ]
    }
  },
  computed: {
    ballStyle() {
      if (this.ballX === 0 && this.ballY === 0) {
        return {}
      }
      return {
        right: 'auto',
        bottom: 'auto',
        left: `${this.ballX}px`,
        top: `${this.ballY}px`
      }
    }
  },
  mounted() {
    this.createParticles()
    this.animateParticles()
    document.addEventListener('mousemove', this.onDrag)
    document.addEventListener('mouseup', this.stopDrag)
  },
  beforeUnmount() {
    document.removeEventListener('mousemove', this.onDrag)
    document.removeEventListener('mouseup', this.stopDrag)
  },
  methods: {
    startDrag(e) {
      e.stopPropagation()
      this.isDragging = true
      
      const rect = e.currentTarget.getBoundingClientRect()
      this.dragStartX = e.clientX - rect.left
      this.dragStartY = e.clientY - rect.top
      
      if (this.ballX === 0 && this.ballY === 0) {
        this.ballX = rect.left
        this.ballY = rect.top
      }
    },
    onDrag(e) {
      if (!this.isDragging) return
      
      this.ballX = e.clientX - this.dragStartX
      this.ballY = e.clientY - this.dragStartY
      
      // 限制在窗口范围内
      this.ballX = Math.max(0, Math.min(window.innerWidth - 80, this.ballX))
      this.ballY = Math.max(0, Math.min(window.innerHeight - 80, this.ballY))
    },
    stopDrag() {
      this.isDragging = false
    },
    toggleExpand() {
      if (this.isDragging) {
        return
      }
      this.isExpanded = !this.isExpanded
    },
    sendPrompt(prompt) {
      this.inputText = prompt.text
      this.sendMessage()
    },
    sendMessage() {
      if (!this.inputText.trim()) return
      
      const userMessage = {
        type: 'user',
        content: this.inputText,
        time: this.getCurrentTime()
      }
      
      this.messages.push(userMessage)
      let messages = this.messages.map(v=>{return {role:v.type,content:v.content}})
      console.log(document.querySelector('#rootView').textContent)
      messages.unshift({role:'user',content:'当前页面内容:'+document.querySelector('#rootView').textContent})
     
      // messages.unshift({role:'user',content:'系统路由表:'+JSON.stringify(this.$routes)})
     
      
      
      fetch(this.$api.defaults.baseURL+'/ai/chat', {
        method: 'POST',
        body: JSON.stringify({
          messages,
          'stream': true,
        }), headers: {
          ...this.$api.defaults.headers,
          'Content-Type': 'application/json',
        }}).then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const that = this;
        const reader = response.body.getReader(); // 获取流读取器
        const decoder = new TextDecoder(); // 创建解码器
        let result = '';
        this.messages.push({
          type:'assistant',
          content:result,
          time:this.getCurrentTime()
        })
        const ReadStream = ()=>{
          reader.read().then(({done, value})=>{
            if (done) {
              this.$set(this.messages[this.messages.length-1],'loading',false)
              this.$set(this.messages[this.messages.length-1],'toExecute',true)
               this.inputText = ''
             
              return;
            }
            const decodedText = decoder.decode(value, {stream: true});
            result += decodedText;
            let action = false
            let actionName = null
            let params = null
            let actionIndex = result.indexOf('{#')
            let actionIndexEnd = result.indexOf('}',actionIndex)
            console.log(actionIndex,actionIndexEnd)
            if(actionIndex !== -1){
              action = true
              if(actionIndexEnd != -1){
                let data = result.substring(actionIndex+2,actionIndexEnd).split(':')
                console.log(data)
                actionName = data[0]
                params = data[1]
              }
            }
            let message = {
              type:'assistant',
              content:result,
              time:this.getCurrentTime(),
              action,
              loading:true,
              actionName,
              params
            }
            this.$set(this.messages, this.messages.length-1, message)
            this.$nextTick(() => {
              this.scrollToBottom()
            })
            ReadStream();
          });
        };


        ReadStream();
      })
      .catch((e) => {
        this.Error(e);
      });

    },
    getAIResponse(question) {
      // 简单的模拟回复
      const responses = [
        '我明白你的问题了，让我来帮你分析一下...',
        '这是一个很好的问题！根据我的理解...',
        '关于这个问题，我的建议是...',
        '让我为你详细解答一下...'
      ]
      return responses[Math.floor(Math.random() * responses.length)]
    },
    getCurrentTime() {
      const now = new Date()
      return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`
    },
    scrollToBottom() {
      if (this.$refs.messageList) {
        this.$refs.messageList.scrollTop = this.$refs.messageList.scrollHeight
      }
    },
    createParticles() {
      if (!this.$refs.particles) return
      
      for (let i = 0; i < 20; i++) {
        const particle = document.createElement('div')
        particle.className = 'particle'
        particle.style.left = Math.random() * 100 + '%'
        particle.style.top = Math.random() * 100 + '%'
        particle.style.animationDelay = Math.random() * 2 + 's'
        this.$refs.particles.appendChild(particle)
      }
    },
    animateParticles() {
      // 粒子动画已通过CSS实现
    }
  }
}
</script>

<style lang="less" scoped>
.aibot-container {
  position: fixed;
  cursor:pointer;
  z-index: 10000;
  pointer-events: none;
  
  > * {
    pointer-events: all;
  }

  
// AI球体样式
.aibot {
  position: fixed;
  right: 50px;
  bottom: 50px;
  width: 80px;
  height: 80px;
  cursor: move;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    transform: scale(1.1);
    
    .ripple {
      animation-play-state: running;
    }
  }
  
  // 外发光效果
  .glow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background: radial-gradient(circle, rgba(99, 102, 241, 0.3) 0%, transparent 70%);
    border-radius: 50%;
    animation: pulse 2s ease-in-out infinite;
  }
  
  // 主球体
  .ai-ball {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    box-shadow: 0 8px 32px rgba(99, 102, 241, 0.4);
    overflow: hidden;
    
    // 流动渐变
    .flow-gradient {
      position: absolute;
      width: 200%;
      height: 200%;
      background: linear-gradient(45deg, 
        transparent 30%, 
        rgba(255, 255, 255, 0.1) 50%, 
        transparent 70%);
      animation: flow 3s linear infinite;
      top: -50%;
      left: -50%;
    }
    
    // 内部球体
    .ball-inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 60px;
      height: 60px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 24px;
      
      svg {
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
      }
    }
  }
  
  // 涟漪效果
  .ripple {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    border: 2px solid rgba(99, 102, 241, 0.5);
    border-radius: 50%;
    animation: ripple 2s ease-out infinite;
    animation-play-state: paused;
    
    &:nth-child(3) {
      animation-delay: 0.5s;
    }
    
    &:nth-child(4) {
      animation-delay: 1s;
    }
    
    &:nth-child(5) {
      animation-delay: 1.5s;
    }
  }
  
  // 粒子容器
  .particles {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 120px;
    height: 120px;
    pointer-events: none;
    
    .particle {
      position: absolute;
      width: 3px;
      height: 3px;
      background: rgba(99, 102, 241, 0.6);
      border-radius: 50%;
      animation: float 3s ease-in-out infinite;
    }
  }
}

// 聊天界面
.ai-chat-interface {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 600px;
  height: 600px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
  // 头部
  .ai-chat-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    
    .ai-chat-header-left {
      display: flex;
      align-items: center;
      gap: 12px;
      
      .ai-avatar {
        position: relative;
        width: 40px;
        height: 40px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        
        .avatar-glow {
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          animation: pulse 2s ease-in-out infinite;
        }
      }
      
      .ai-name {
        font-size: 16px;
        font-weight: 600;
      }
    }
    
    .ai-header-actions {
      .minimize-btn {
        background: rgba(255, 255, 255, 0.2);
        border: none;
        color: white;
        width: 32px;
        height: 32px;
        border-radius: 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
        
        &:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: scale(1.05);
        }
      }
    }
  }
  
  // 消息列表
  .message-list {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.1);
      border-radius: 3px;
      
      &:hover {
        background: rgba(0, 0, 0, 0.2);
      }
    }
    
    .message-item {
      display: flex;
      gap: 12px;
      align-items: flex-start;
      animation: slideIn 0.3s ease-out;
      
      &.user {
        flex-direction: row-reverse;
        
        .message-content {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          
          .message-time {
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
      
      .message-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        flex-shrink: 0;
      }
      
      .message-content {
        max-width: 70%;
        background: #f3f4f6;
        padding: 12px 16px;
        border-radius: 12px;
        
        .message-text {
          font-size: 14px;
          line-height: 1.5;
          margin-bottom: 6px;
          white-space:pre-wrap;
        }
        
        .message-time {
          font-size: 11px;
          color: #9ca3af;
        }
      }
    }
  }
  
  // 快捷提示
  .quick-prompts {
    padding: 0 20px 20px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    
    .prompt-item {
      background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
      padding: 16px;
      border-radius: 12px;
      cursor: pointer;
      transition: all 0.2s;
      display: flex;
      flex-direction: column;
      gap: 8px;
      
      &:hover {
        background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
      
      .prompt-icon {
        font-size: 24px;
      }
      
      .prompt-text {
        font-size: 13px;
        color: #374151;
        line-height: 1.4;
      }
    }
  }
  
  // 输入容器
  .input-container {
    padding: 20px;
    background: white;
    border-top: 1px solid #e5e7eb;
    
    .input-wrapper {
      display: flex;
      gap: 12px;
      
      .chat-input {
        flex: 1;
        padding: 12px 16px;
        border: 2px solid #e5e7eb;
        border-radius: 12px;
        font-size: 14px;
        outline: none;
        transition: all 0.2s;
        
        &:focus {
          border-color: #667eea;
        }
        
        &::placeholder {
          color: #9ca3af;
        }
      }
      
      .send-btn {
        width: 44px;
        height: 44px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        border-radius: 12px;
        color: white;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
        
        &:hover:not(:disabled) {
          transform: scale(1.05);
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
        }
        
        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
  }
}

// 动画
@keyframes pulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.3;
  }
}

@keyframes flow {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes ripple {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.6;
  }
  100% {
    transform: translate(-50%, -50%) scale(2);
    opacity: 0;
  }
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translate(calc(var(--x, 0) * 1px), calc(var(--y, 0) * 1px));
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  transform: scale(0.8);
  transform-origin: bottom right;
}

// 深色模式适配
@media (prefers-color-scheme: dark) {
  .chat-interface {
    background: rgba(30, 30, 30, 0.95);
    
    .message-list {
      .message-item.ai {
        .message-content {
          background: #374151;
          color: #f3f4f6;
        }
      }
    }
    
    .quick-prompts {
      .prompt-item {
        background: #374151;
        color: #f3f4f6;
        
        &:hover {
          background: #4b5563;
        }
      }
    }
    
    .input-container {
      background: #1f2937;
      border-top-color: #374151;
      
      .chat-input {
        background: #374151;
        border-color: #4b5563;
        color: #f3f4f6;
        
        &:focus {
          border-color: #667eea;
        }
      }
    }
  }
}

}

</style>